const common = (
  state = {
    adapter: {}
  },
  action
) => {
  switch (action.type) {
    case "UPDATE_ADAPTTER_DATA":
      return {
        ...state,
        adapter: action.adapter
      };
    default:
      return state;
  }
};

export default common;
